export { default } from './AccordionItem';



// WEBPACK FOOTER //
// ./src/components/molecules/AccordionItem/index.js